import React, {useEffect, useState} from 'react';
import {Controller} from "react-hook-form";
import debounce from 'lodash/debounce'
import {integrationService} from "../../service/integrationService";
import {trafficSourceSelectPaperStyles} from "./TrafficSourceDesign";
import {Autocomplete, CircularProgress, TextField} from "@mui/material";

function IntegrationSelect({control, setValue, errors, trafficSourceData, setRequestError}) {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [findIntegrationLoading, setFindIntegrationLoading] = useState(false);

    useEffect(() => {
        if (trafficSourceData?.integrationId > 0) {
            setFindIntegrationLoading(true);
            integrationService.findIntegration(trafficSourceData?.integrationId)
                .then((result) => {
                    let accountId = "";
                    let adAccountName = "";
                    result?.integrationCredentials.forEach(c => {
                        if (c?.keyName === "nb_account_id" || c?.keyName === "smartnews_ad_account_id" || c?.keyName === "mgid_account_id" || c?.keyName === "fb_ad_account_id" || c?.keyName === "google_ad_account_id" || c?.keyName === "microsoft_ad_account_id" || c?.keyName === "taboola_account_id" || c?.keyName === "tt_ad_account_id" || c?.keyName === "mediago_ad_account_id" || c?.keyName === "popin_ad_account_id") {
                            accountId = c?.keyValue;
                        }
                        if (c?.keyName === "nb_account_name" || c?.keyName === "smartnews_ad_account_name" || c?.keyName === "fb_ad_account_name" || c?.keyName === "google_ad_account_name" || c?.keyName === "microsoft_ad_account_name" || c?.keyName === "outbrain_account_name" || c?.keyName === "tt_ad_account_name" || c?.keyName === "mediago_ad_account_name") {
                            adAccountName = c?.keyValue;
                        }
                    });

                    let label = result?.networkName;
                    if (accountId !== "") {
                        label += " | " + accountId;
                    }
                    if (adAccountName !== "") {
                        label += " | " + adAccountName;
                    }

                    setValue("integrationId", {value: result?.id, label: label});
                }).catch((error) => {
                if (error?.response?.data?.error) {
                    setRequestError(error?.response?.data?.error);
                }
            }).finally(() => {
                setFindIntegrationLoading(false);
            });
        }
    }, [trafficSourceData, control, setRequestError, setValue])

    useEffect(() => {
        if (open && options?.length === 0) {
            setLoading(true);
            integrationService.getIntegrations({category: "traffic-source"}).then((result) => {
                setOptions(
                    result.map(i => {
                        let accountId = "";
                        let adAccountName = "";
                        i?.integrationCredentials.forEach(c => {
                            if (c?.keyName === "nb_account_id" || c?.keyName === "smartnews_ad_account_id" || c?.keyName === "fb_ad_account_id" || c?.keyName === "google_ad_account_id" || c?.keyName === "microsoft_ad_account_id" || c?.keyName === "taboola_account_id" || c?.keyName === "tt_ad_account_id" || c?.keyName === "mgid_account_id" || c?.keyName === "mediago_ad_account_id" || c?.keyName === "popin_ad_account_id") {
                                accountId = c?.keyValue;
                            }
                            if (c?.keyName === "nb_account_name" || c?.keyName === "smartnews_ad_account_name" || c?.keyName === "fb_ad_account_name" || c?.keyName === "google_ad_account_name" || c?.keyName === "microsoft_ad_account_name" || c?.keyName === "outbrain_account_name" || c?.keyName === "tt_ad_account_name" || c?.keyName === "mediago_ad_account_name") {
                                adAccountName = c?.keyValue;
                            }
                        });

                        let label = i?.networkName;
                        if (accountId !== "") {
                            label += " | " + accountId;
                        }
                        if (adAccountName !== "") {
                            label += " | " + adAccountName;
                        }

                        return {
                            value: i?.id,
                            label: label
                        }
                    })
                );
            }).catch((error) => {
                if (error?.response?.data?.error) {
                    setRequestError(error?.response?.data?.error);
                }
            }).finally(() => {
                setLoading(false);
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, setRequestError]);

    const handleSearch = debounce(searchTerm => {
        setSearch(searchTerm);
    }, 800);

    return (
        <Controller
            render={({field: {onChange, ...props}}) => (
                <Autocomplete
                    id="integration-select"
                    open={open}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                    getOptionLabel={(option) => option?.label ? option.label : ""}
                    options={options}
                    loading={loading || findIntegrationLoading}
                    fullWidth
                    slotProps={{paper: {sx: trafficSourceSelectPaperStyles}}}
                    renderInput={params => (
                        <TextField {...params} error={!!errors?.integrationId} variant="outlined" size="small"
                            label="Ad account integration" placeholder="Choose an integration" fullWidth
                            value={search} onChange={e => handleSearch(e.target.value)}
                            slotProps={{inputLabel: {shrink: true}, input: {...params.InputProps,
                                endAdornment: <>{(loading || findIntegrationLoading) && <CircularProgress size={16} color="inherit"/>}{params.InputProps.endAdornment}</>}}}/>
                    )}
                    onChange={(e, data) => onChange(data)}
                    {...props}
                />
            )}
            name="integrationId"
            control={control}
            defaultValue={null}
            onChange={([, data]) => data}
        />
    );
}

export default IntegrationSelect;